export default "/_next/static/assets/fonts/GoodOTNarrow-Ultra.a656c4692b9368d3c6ac04145f753451.woff2";